<template>
  <section class="proposal-page__section packaging">
    <article class="proposal-page__cut packaging__black-cut">
      <div class="pp-container --is-narrow">
        <header class="proposal-page__section-heading">
          <h2 class="proposal-page__section-title">So wird Auspacken zum Erlebnis</h2>
          <p class="proposal-page__section-description">Edle Geschenkboxen mattschwarz veredelt und mit handverlesenen Delikatessen befüllt – Präsente mit Wow-Effekt!</p>
        </header>

        <div class="packaging__spotlight">
          <img
            v-if="image"
            :srcset="`
              ${image['1536x1536']}?format=${webPFormat('png')}&width=1500&nearlossless=1&compression=4 1500w,
              ${image['1536x1536']}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4 950w
            `"
            sizes="
              (max-width: 36em) 100vw,
              59em
            "
            :src="`${image['1536x1536']}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4`"
            class="packaging__photo --is-level1"
            alt="Componata's Packaging"
            data-aos="fade-in" data-aos-duration="1400"
          >

          <img
            v-else
            :srcset="`
              ${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=1900&nearlossless=1&compression=4 1900w,
              ${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4 950w
            `"
            sizes="
              (max-width: 36em) 100vw,
              59em
            "
            :src="`${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4`"
            class="packaging__photo"
            alt="Componata's Packaging"
            data-aos="fade-in" data-aos-duration="1400"
          >
        </div>
      </div>
    </article>

    <article class="proposal-page__cut packaging__gray-cut">
      <div class="pp-container">
        <ul class="packaging__features">
          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-handmade.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">In <b class="packaging__germany-text-mask">Deutschland</b> mit Liebe von Hand verpackt</h3>
            <p class="packaging__feature-description">Jede Präsentbox wird nach Ihren Wünschen und Anforderungen von Hand verpackt.</p>
          </li>

          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-box.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">Atemberaubende mattschwarze Box mit Magnetverschluss</h3>
<p class="packaging__feature-description">Edle Geschenkboxen mattschwarz veredelt und mit handverlesenen Delikatessen befüllt – Präsente mit Wow-Effekt!</p>
          </li>

          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-truck.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">Direktversand an Beschenkte</h3>
<p class="packaging__feature-description">Unsere Präsente sind stets geschenkfertig. Unabhängig von der Stückzahl ist ein direkter Versand an Ihre Mitarbeiter, Geschäftspartner und Kunden möglich.</p>
          </li>
        </ul>
      </div>
    </article>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'Packaging',
  mixins: [helperMixin],
  props: ['image'],
};
</script>

<style lang="scss" scoped>
/**
 * Packaging
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present packaging features
 * @since 2020-10-28
**/

.proposal-page__section-description {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

$component: 'packaging';

.#{$component} {
  color: #d4d8de;

  &__black-cut {
    background: radial-gradient(#1b1b1b, #0C0C0C 30%);
  }

  &__gray-cut {
    @include padding-top(map-get($spacers, 4) * 3 !important);
    background: #1C1C1C;
  }

  // Spotlight
  &__spotlight {
    display: flex;
    justify-content: center;
    overflow: hidden;
    @include padding-top(map-get($spacers, 4));
  }

  &__photo {
    max-width: 100%;
    @include margin-top(- map-get($spacers, 6) * 3);
    @include margin-bottom(- map-get($spacers, 6) * 5);
    @include imageRendering;

    &.--is-level1 {
      max-width: 70%;
      margin-left: auto;
      margin-right: auto;
      @include margin-top(- map-get($spacers, 6) * 0);
      @include margin-bottom(- map-get($spacers, 6) * 3);
    }
  }

  // Features
  &__features {
    @include unlist;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__feature {
    flex: 0 0 28%;
  }

  &__feature-icon {
    @include rfs(3.4rem, width);
  }

  &__feature-title {
    @include margin-top(map-get($spacers, 2));
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    line-height: 130%;
  }

  &__feature-description {
    margin: 0;
    font-weight: $font-weight-lighter;
  }

  &__germany-text-mask {
    font-weight: $font-weight-bolder;
    // text-shadow: 1px 1px 4px lighten(#1C1C1C, 10%);
    background: linear-gradient(to right, #616161, #9a4756, #b7ac83);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__features {
      @include margin-bottom(- map-get($spacers, 4) * 3)
    }

    &__feature {
      flex: 0 0 48%;
      @include margin-bottom(map-get($spacers, 4) * 3);
    }

    @at-root .proposal-page__section-description {
      width: 100%;
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__feature {
      flex: 0 0 100%;
      @include margin-bottom(map-get($spacers, 4) * 4);
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
